<template>
  <div>
    <base-header type="gradient-warning" class="pb-6 pb-8 pt-5 pt-md-8">
      <div class="row mb-2">
        <div class="col-12 col-md-12 col-lg">
          <h1 class="text-white pt-3 px-3">หน้าจัดการตัวแทนจำหน่าย</h1>
          <p
            class="text-white pb-3 px-3"
          >ตารางรายละเอียดตัวแทนจำหน่าย</p>
        </div>
        <div class="col-12 col-md-12 col-lg-4 text-right">
            <div
                v-b-modal.modalAddAgent
                class="btn btn-outline-light btn-icon btn-icon-add py-3"
                role="button"
                v-if="auth0RoleUsage('agentmanagecreate')"
            >
                <i class="fas fa-plus"></i>
                <p>เพิ่มตัวแทนจำหน่าย</p>
            </div>
        </div>
      </div>
    </base-header>
    <BlockUI v-if="busy">
      <div class="loader"></div>
    </BlockUI>

    <div class="container-fluid mt--7 mb-5">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <div class="row justify-content-between">
                <div class="col d-flex align-self-center">
                  <h3 class="text-muted">ตารางแสดงรายละเอียดตัวแทนจำหน่ายทั้งหมด</h3>
                </div>
                <div class="col-12 col-md-12 col-lg-4">
                  <b-input-group>
                    <b-form-input  placeholder="ค้นหาตัวแทนจำหน่าย"></b-form-input>
                  </b-input-group>
                </div>
              </div>
            </div>
            <div>
              <b-table
                show-empty
                :items="agents"
                :fields="fields"
                :filter="filter"
                responsive
                class="scroll-bar-pop"
              >
                <template slot="index" slot-scope="data">{{ data.index + 1 }}</template>
                <template slot="manage" slot-scope="row">
                    <!-- <button class="btn px-3 btn-sm btn-info"  v-b-modal.modalEditAgent @click="setValueModalEdit( row.item)">แก้ไข</button> -->
                    <button
                        class="btn btn-sm btn-info px-3"
                        @click="$router.push({name:'agent',params:{Id:row.item.id}})"
                    >แก้ไข</button>
                    <button 
                        class="btn px-3 btn-sm btn-danger" 
                        @click="modalDelete( row.item.id )"
                        v-if="auth0RoleUsage('agentmanagedelete')"
                    >ลบ</button>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal เพิ่มตัวแทนจำหน่าย -->
    <b-modal id="modalAddAgent"  hide-footer title="เพิ่มตัวแทนจำหน่าย" @hide="defaultInputAdd()">
      <form @submit.prevent="addUser()">
        <card shadow type="secondary" class="m--4">
          <template>
            <div class="row">
                <div class="col-lg-12">
                    <div class="form-group">
                        <label>
                            <span class="text-danger">*</span> ชื่อ-สกุล
                        </label>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="ชื่อ-สกุล"
                            v-model="inputAdd.name"
                        />
                        <div v-if="$v.inputAdd.name.$error" class="invalid-feedback d-block">
                          <span v-if="!$v.inputAdd.name.required">กรุณากรอก ชื่อ - สกุล</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>
                            <span class="text-danger">*</span> email
                        </label>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="email"
                            v-model="inputAdd.email"
                        />
                        <div v-if="$v.inputAdd.email.$error" class="invalid-feedback d-block">
                          <span v-if="!$v.inputAdd.email.required">กรุณากรอกอีเมล์</span>
                          <span v-if="!$v.inputAdd.email.email">รูปแบบอีเมล์ไม่ถูกต้อง</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>
                            <span class="text-danger">*</span> password
                        </label>
                        <input
                            type="password"
                            class="form-control"
                            placeholder="password"
                            v-model="inputAdd.password"
                            autocomplete=""
                        />
                        <div v-if="$v.inputAdd.password.$error" class="invalid-feedback d-block">
                          <span v-if="!$v.inputAdd.password.required">กรุณากรอกรหัสผ่าน</span>
                          <span v-if="!$v.inputAdd.password.minLength">กรุณากรอก"รหัสผ่าน"อย่างน้อย 
                            {{$v.inputAdd.password.$params.minLength.min}} ตัวอักษร
                          </span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12">
                  <div class="form-group">
                    <b-form-checkbox
                      v-model="inputAdd.wallet"
                      :value="true"
                      :unchecked-value="false"
                      :disabled="inputAdd.forceUseWallet"
                    >
                      เปิดใช้งาน Wallet
                    </b-form-checkbox>
                  </div>
                </div>
            </div>
            <template v-if="inputAdd.wallet === true">
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> pgw_public_key
                    </label>
                    <b-form-input v-model="inputAdd.pgwPublicKey"></b-form-input>
                    <div v-if="$v.inputAdd.pgwPublicKey.$error" class="invalid-feedback d-block">
                      <span v-if="!$v.inputAdd.pgwPublicKey.required">กรุณากรอก pgw_public_key</span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label>
                        <span class="text-danger"></span> pgw_private_key
                    </label>
                    <b-form-input v-model="inputAdd.pgwPrivateKey"></b-form-input>
                    <!-- <div v-if="$v.inputAdd.pgwPrivateKey.$error" class="invalid-feedback d-block">
                      <span v-if="!$v.inputAdd.pgwPrivateKey.required">กรุณากรอก pgw_private_key</span>
                    </div> -->
                  </div>
                </div>
              </div>
            </template>     
          </template>
        </card>
        <div slot="modal-footer" class="w-100 text-right pt-5">
          <b-button variant="secondary" @click="$bvModal.hide('modalAddAgent') , defaultInputAdd()">ยกเลิก</b-button>
          <b-button variant="success" type="submit">ยืนยัน</b-button>
        </div>
      </form>
    </b-modal>
    <!-- modal แก้ไขตัวแทนจำหน่าย -->
    <!-- <b-modal id="modalEditAgent"  hide-footer title="แก้ไขตัวแทนจำหน่าย" @hide="defaultInputAdd()">
      <form @submit.prevent="updateAgent()">
        <card shadow type="secondary" class="m--4">
          <template>
            <div class="row">
                <div class="col-lg-12">
                    <div class="form-group">
                        <label>
                            <span class="text-danger">*</span> แก้ไข ชื่อ-สกุล
                        </label>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="ชื่อ-สกุล"
                            v-model="inputAdd.name"
                        />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>
                            <span class="text-danger">*</span> แก้ไข email
                        </label>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="email"
                            v-model="inputAdd.email"
                        />
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>
                            <span class="text-danger">*</span> แก้ไข password
                        </label>
                        <input
                            type="password"
                            class="form-control"
                            placeholder="password"
                            v-model="inputAdd.password"
                            autocomplete=""
                        />
                    </div>
                </div>
                <div class="col-lg-12">
                  <div class="form-group">
                    <b-form-checkbox
                      v-model="inputAdd.wallet"
                      :value="true"
                      :unchecked-value="false"
                      :disabled="inputAdd.forceUseWallet"
                    >
                      เปิดใช้งาน Wallet
                    </b-form-checkbox>
                  </div>
                </div>
                <template v-if="inputAdd.wallet === true">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label>
                            <span class="text-danger">*</span> pgw_public_key
                        </label>
                        <b-form-input v-model="inputAdd.pgwPublicKey"></b-form-input>
                        <div v-if="$v.inputAdd.pgwPublicKey.$error" class="invalid-feedback d-block">
                          <span v-if="!$v.inputAdd.pgwPublicKey.required">กรุณากรอก pgw_public_key</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label>
                            <span class="text-danger"></span> pgw_private_key
                        </label>
                        <b-form-input v-model="inputAdd.pgwPrivateKey"></b-form-input>
                      </div>
                    </div>
                </template>
            </div>
            <hr class="my-4" />
            <div class="row">
                <div class="col-12">
                  <label class="mb-0">ขนส่งที่ตัวแทนจำหน่ายมี</label>
                </div>
                <div class="col-12">
                <h6 class="mb-0 text-muted d-flex justify-content-center" v-if="chkBoxCourier.hasCourier.length < 1">ยังไม่มีขนส่งที่ถูกสร้าง</h6>
                </div>
                <div class="col-lg-6" v-for="(courier , index) in chkBoxCourier.hasCourier" :key="courier.id">
                    {{index+1}}.) {{courier.name}} <br />
                    <label class="text-muted">description: {{courier.description}}</label>
                </div>
            </div>
            <hr class="my-4" />
            <div class="row">
                <div class="col-lg-12">
                    <b-form-group label="เลือกขนส่งที่ต้องการเปิดใช้บริการ">
                        <b-form-checkbox
                            v-for="courier in chkBoxCourier.courierShippop"
                            v-model="chkBoxCourier.selected"
                            class="col-lg-6 m-0"
                            :key="courier.id"
                            :value="courier.id"
                            inline
                            >
                            {{ courier.name }} <br />
                            <label class="text-muted">description: {{courier.description}}</label>
                        </b-form-checkbox>
                    </b-form-group>
                </div>
            </div>         
          </template>
        </card>
        <div slot="modal-footer" class="w-100 text-right pt-5">
          <b-button variant="secondary" @click="$bvModal.hide('modalEditAgent') , defaultInputAdd()">ยกเลิก</b-button>
          <b-button variant="success" type="submit">ยืนยัน</b-button>
        </div>
      </form>
    </b-modal> -->
  </div>
</template>
<script>
const API_URL = process.env.VUE_APP_API
import validatePop from "../plugins/validatePop.js";
import {
  required,
  minLength,
  email,
  requiredIf
} from "vuelidate/lib/validators"
import { auth0RoleUsage } from "@/helpers/auth0"

export default {
  name: "agentManage",
  data() {
    return {
        busy:false,
        userLogin:'',
        inputAdd: {
            id:"",
            name: "",
            email: "",
            password: "",
            wallet: this.$THEME.wallet?true:false,
            pgwPublicKey: "",
            pgwPrivateKey: "",
            forceUseWallet: this.$THEME.forceUseWallet?true:false
        },
        agents: [],
        chkBoxCourier: {
            selected: [],
            courierShippop: [],
            hasCourier:[],
        },
        filter: null,
        fields: [
            { key: "index", label: "#", sortable: true },
            { key: "dealer_id", label: "รหัสตัวแทนจำหน่าย", sortable: true },
            { key: "name", label: "ชื่อสกุล", sortable: true },
            { key: "email", label: "ไอดีสมาชิก", sortable: true },
            { key: "manage", label: "การจัดการ", sortable: false }
        ],
        auth0RoleUsage: auth0RoleUsage
    }
  },
  validations(){
    return {
      inputAdd: {
        name: { required },
        email: { required, email },
        password: { required, minLength: minLength(8) },
        pgwPublicKey: this.inputAdd.wallet ? {required}: {},
      }
    }
    // pgwPrivateKey: this.inputAdd.wallet ? {required}: {},
  },
  mounted() {
    this.getAgent();
    this.userLogin = JSON.parse(localStorage.getItem("user"));
  },
  methods: {
    defaultInputAdd(){
        this.inputAdd = {
            id:"",
            name: "",
            email: "",
            password: "",
            pgwPublicKey: "",
            pgwPrivateKey: "",
            forceUseWallet: this.$THEME.forceUseWallet?true:false
        }
    },
    setValueModalEdit( item ){
        this.getDataCouriers()
        let index = this.agents.findIndex( index => {
            return index.id == item.id
        })
        this.inputAdd.id = item.id
        this.inputAdd.name = item.name
        this.inputAdd.email = item.email
        this.inputAdd.password = '' 
        this.inputAdd.forceUseWallet = item.wallet_open === true ? true : false
        if( this.inputAdd.forceUseWallet ){
          this.inputAdd.wallet = false
        }
        this.chkBoxCourier.selected = []
        this.chkBoxCourier.hasCourier = this.agents[index].default_courier
    },
    getDataCouriers() {
      this.$http
        .get(API_URL + "/shop/superadmin/couriers", {
          headers: {
            Token: localStorage.getItem("access_token")
          }
        })
        .then(res => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            if (checkError.notices == "token is expired") {
              this.$router.push("/logout");
            }
            this.modalError('มีบางอย่างผิดปกติ');
            return false;
          }
          this.chkBoxCourier.courierShippop = res.data.data.filter(( courier ) =>{
            return courier.is_shippop == 1 && ( courier.expired_date == null || new Date(courier.expired_date).getTime() >= new Date().getTime() )
          })
          this.chkBoxCourier.courierGen = res.data.data.filter(( courier ) =>{
            return courier.is_shippop == 0
          })

        });
    },
   getAgent() {
       this.busy = true
      this.$http
        .get(API_URL + "/shippop/agents", {
          headers: {
            Token: localStorage.getItem("access_token")
          }
        })
        .then(res => {
          let checkError = validatePop( res )
            if( !checkError.status ){
              if( checkError.notices == "token is expired"){
                this.$router.push("/logout")
              }
              this.busy = false
              this.modalError('มีบางอย่างผิดปกติ');
              return false
            }
          this.agents = res.data.data
          this.busy = false
        })
    },
    addUser() {
        this.busy = true
        this.$v.inputAdd.$touch();
        if (this.$v.inputAdd.$invalid) {
          this.busy = false
          return false
        }
        this.$http
        .post(
            API_URL + "/shippop/agent",
            {
              name: this.inputAdd.name,
              email: this.inputAdd.email,
              password: this.inputAdd.password,
              walletOpen: this.inputAdd.wallet,
              pgw_public_key: this.inputAdd.pgwPublicKey,
              pgw_private_key:this.inputAdd.pgwPrivateKey
            },
            {
            headers: { Token: localStorage.getItem("access_token") }
            }
        )
        .then(res => {
            this.busy = false
            let checkError = validatePop( res )
            if( !checkError.status ){
                this.modalError(JSON.stringify(res.data));
                return false
            }
            this.modalSuccess("เพิ่มข้อมูลเรียบร้อยค่ะ")
            this.getAgent()
            this.$bvModal.hide('modalAddAgent')
            this.defaultInputAdd()
        })
    },
    removeAgent( id ) {
      this.$http
        .delete(API_URL + "/shippop/agent/" + id, {
          headers: {
            Token: localStorage.getItem("access_token")
          }
        })
        .then(res => {
          let checkError = validatePop( res )
            if( !checkError.status ){
              this.modalError('มีบางอย่างผิดปกติ');
              this.busy = false
              return false
            }
          this.busy = false
            this.modalSuccess("ลบข้อมูลสำเร็จ");
            this.getAgent()
        })
    },
    // updateAgent() {
    //     this.busy = true
    //     this.$v.inputAdd.$touch();
    //     if (this.$v.inputAdd.pgwPublicKey.$invalid) {
    //       this.busy = false
    //       return false
    //     }
    //     this.$http
    //     .put(
    //         API_URL + "/shippop/agent/" + this.inputAdd.id,
    //         {
    //           name: this.inputAdd.name,
    //           email: this.inputAdd.email,
    //           password: this.inputAdd.password,
    //           addCouriers: this.chkBoxCourier.selected,
    //           wallet_open: this.inputAdd.wallet,
    //           pgw_public_key: this.inputAdd.pgwPublicKey,
    //           pgw_private_key:this.inputAdd.pgwPrivateKey
    //         },
    //         {
    //         headers: { Token: localStorage.getItem("access_token") }
    //         }
    //     )
    //     .then(res => {
    //         this.busy = false
    //         let checkError = validatePop( res )
    //         if( !checkError.status ){
    //             this.busy = false
    //             this.modalError('มีบางอย่างผิดปกติ');
    //             return false
    //         }
    //         this.$bvModal.hide('modalEditAgent')
    //         this.modalSuccess("แก้ไขสมาชิกเสร็จสิ้น")
    //         this.defaultInputAdd()
    //     })
    // },
    modalDelete( id ) {
      this.$bvModal
        .msgBoxConfirm(`คุณต้องการจะลบข้อมูลตัวแทนจำหน่าย `, {
          title: "กรุณายืนยัน",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "ยืนยัน",
          cancelTitle: "ยกเลิก",
          contentClass: "modal-confirm",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            this.removeAgent( id );
          }
        })
    },
    modalSuccess( msgBody ) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "SUCCESS",
        size: "sm",
        buttonSize: "sm",
        okVariant: "success",
        okTitle: "ตกลง",
        contentClass: "modal-success",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true
      }).then( value => {
          if(value){
              this.getAgent()
          }
      })
    },
    modalError( msgBody ) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "ERROR",
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        okTitle: "ลองอีกครั้ง",
        contentClass: "modal-errors",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true
      });
    }
  }
};
</script>